(function () {

    angular.module('tmx-app').controller('leadsCtrl', ['$mdSidenav', 'menu','$state', 'tmxUtility','LeadService',

        function LeadsCtrl($mdSidenav, menu,$state, tmxUtility,LeadService) {
            var leadVM = this;
            var copy = tmxUtility.copy;
            var exists = tmxUtility.exists;
            leadVM.formatDate = tmxUtility.formatDateForCompany;
            leadVM.menu=menu;

            leadVM.editPermission= tmxUtility.checkPermission("Private.Leads","Edit");
              //#region ------ Grid Initializations and methods------------

            var gridColumns = [
                // {
                //     field: "LeadId",
                //     title: "Lead Id",
                //     type: "text",
                //     template: "<md-button class='tmx-primary-text'  ng-click='LeadsCtrl.clickEdit(dataItem)' ng-bind='dataItem.LeadId'></md-button>",
                //     headerTemplate: "<span  ng-class=\"{ 'filter-active' : LeadsCtrl.isFiltered('LeadId')}\" >{{'LeadId' | translate}}<i class='fa fa-filter' ng-if='LeadsCtrl.isFiltered(\"LeadId\")' ></i></span>"
                // },
                {
                    field: "LeadType",
                    title: "Lead Type",
                    type: "text",
                    template: "<md-button ng-disabled='!LeadsCtrl.editPermission' class='tmx-primary-text-grid'  ng-click='LeadsCtrl.clickEdit(dataItem)' ng-bind='dataItem.LeadType'></md-button>",
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : LeadsCtrl.isFiltered('LeadType')}\" >{{'LeadType' | translate}}<i class='fa fa-filter' ng-if='LeadsCtrl.isFiltered(\"LeadType\")' ></i></span>"
                },
                {
                    field: "FullName",
                    title: "Name",
                    type: "text",
                    template: "<md-button ng-disabled='!LeadsCtrl.editPermission' class='tmx-primary-text-grid'  ng-click='LeadsCtrl.clickEdit(dataItem)' ng-bind='dataItem.FullName'></md-button>",
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : LeadsCtrl.isFiltered('FullName')}\" >{{'Name' | translate}}<i class='fa fa-filter' ng-if='LeadsCtrl.isFiltered(\"FullName\")' ></i></span>"
                },
                {
                    field: "GeneratedFrom",
                    title: "Origin",
                    type: "text",
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : LeadsCtrl.isFiltered('GeneratedFrom')}\" >{{'Origin' | translate}}<i class='fa fa-filter' ng-if='LeadsCtrl.isFiltered(\"GeneratedFrom\")' ></i></span>"
                },
                {
                    field: "CreatedBy",
                    title: "Creator",
                    type: "text",
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : LeadsCtrl.isFiltered('CreatedBy')}\" >{{'Creator' | translate}}<i class='fa fa-filter' ng-if='LeadsCtrl.isFiltered(\"CreatedBy\")' ></i></span>"
                },
                {
                    field: "CreatedDate",
                    title: "Created Date",
                    type: "date",
                    search: true,
                    // applySearchRangeForThisDate: true,
                    // template: "<span ng-bind='dataItem.CreatedDate'></span>",
                    template: "<span>{{ dataItem.FormattedCreatedDate}}</span>",                    
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : LeadsCtrl.isFiltered('CreatedDate')}\" >{{'CreatedDate' | translate}}<i class='fa fa-filter' ng-if='LeadsCtrl.isFiltered(\"CreatedDate\")' ></i></span>"
                },
                {
                    field: "IsConverted",
                    title: "Converted",
                    type: "text",
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : LeadsCtrl.isFiltered('IsConverted')}\" >{{'Converted' | translate}}<i class='fa fa-filter' ng-if='LeadsCtrl.isFiltered(\"IsConverted\")' ></i></span>"
                },
                {
                    field: "ApplicationId",
                    title: "Application/Transaction Id",
                    type: "text",
                    template: "{{dataItem.ApplicationId}}",
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : LeadsCtrl.isFiltered('ApplicationId')}\" >{{'ATId' | translate}}<i class='fa fa-filter' ng-if='LeadsCtrl.isFiltered(\"ApplicationId\")' ></i></span>"
                }

            ];

            leadVM.cols = gridColumns;
            leadVM.gridColumns = angular.copy(gridColumns);

            leadVM.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function (o) {
                            if (angular.isDefined(leadVM.searchClear) && leadVM.searchClear == false) {
                                if (exists(leadVM.o)) {
                                    copy(leadVM.o.data, ["filter"], o.data);
                                }
                            }
                            leadVM.searchClear = false;
                            if (!o.fromSideNav) {
                                if ($state.searchClear) {
                                    leadVM.searchClear = true;
                                    $state.searchClear = undefined;
                                }
                            }
                            else {
                                o.data.firstPage = true;
                            }
                            leadVM.o = angular.copy(o);
                            if (leadVM.o.data.firstPage) {
                                selected();
                            }
                            leadVM.filters = leadVM.o.data.filter;
                            LeadService.getByParams(o, true).then(function (response) {
                                parseResppnse(response.data);
                                o.success(response);
                            });
                        },
                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "Total"
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,

                    sort: [{ field: "LeadId", dir: "desc" }],
                },
            // selectable: "multiple, row",
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    pageSize: 10,
                    buttonCount: 5
                },
                sortable: true,
                scrollable: false,
                columns: leadVM.gridColumns
            };
            

            function parseResppnse(data){
                data.forEach(function(dataItem){                                                                            
                    dataItem.FormattedCreatedDate= leadVM.formatDate(dataItem.CreatedDate);    
                    dataItem.ApplicationId =LeadsCtrl.formatString(dataItem.ApplicationId);
                });                                
            }

            leadVM.bulk = [];
            leadVM.container = {};
            $state.data = {
                grid: leadVM.container
            };

            function selected() {
                var dataSource = leadVM.container.leadsGrid.dataSource;
                if (angular.isDefined(leadVM.o) && angular.isDefined(dataSource) &&
                leadVM.o.data.firstPage && dataSource.page() != 1) {//implies data loaded into grid is just the firt page data
                    dataSource.page(1);
                }
            }

              //#endregion

            //#region ----------Scope Functions-----------------

            LeadsCtrl.formatString = function(text){
                if(!exists(text) || text === ""){
                    return 'N/A';
                }
                return text;
            }

            leadVM.toggle = function (navID) {
                $mdSidenav(navID).toggle().then(function () { });
            };

            leadVM.isOpen = function (navID) {
                return $mdSidenav(navID).isOpen();
            };

            //#endregion

            leadVM.onChildState = function () {
                if ($state.current.name.indexOf(".add") > 0 || $state.current.name.indexOf(".edit") > 0) {
                    return true;
                }
            };

            leadVM.clickEdit = function (item) {
                $state.go($state.current.name + ".edit", { "Id": item.LeadId });
            };

        }
    ]);
})();
